module.exports = __webpack_public_path__ + "static/img/151.38d6bc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/互联网金融/151.png
// module id = 3LEQ
// module chunks = 1